import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importProductLoadingApi = createApi({
    reducerPath: "importProductLoading",
    baseQuery,
    tagTypes: ["importProductLoading"], ///v1/import/product/loading/{importProductId}
    endpoints: (builder) => ({
     
        createProductLoading: builder.mutation({
            query: ({ id,...data }) => ({
              url: `import/product/loading/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { productLoading:data },
            }),
            invalidatesTags: ["importProductLoading"],
          }),

          updateProductLoading: builder.mutation({
            query: ({ id, subId, ...data }) => {
      
              return {
                url: `import/product/loading/${id}`,
                method: "PUT",
                body: { productLoading: data },
                headers: {
                  "X-Request-Id": Math.random().toString(36).substring(2),
                },
              };
            },
            invalidatesTags: ["importProductLoading"],
          }),

          getProductLoadId: builder.query({
            query: ({id}) => `import/product/loading/${id}`,
            transformResponse: (response) => response?.data,
            providesTags: ["importProductLoading"],
          }),


        }), 
      });

    export const {
        useCreateProductLoadingMutation,
        useUpdateProductLoadingMutation,
        useLazyGetProductLoadIdQuery,
       

       
        
  
        } = importProductLoadingApi;
